import React from "react";
import Link from "next/link";
import type {UrlObject} from "url";
import {Locale} from "~/i18n-config";
import {localizePathname} from "~/utils/locales";

export type LangLinkProps = {
    href: string | UrlObject;
    lang: Locale | string;
    children: React.ReactNode;
    [key: string]: any;
};

export const LangLink = React.forwardRef<HTMLAnchorElement, LangLinkProps>(
    ({ href, lang, children, ...props }, ref) => {
        return (
            <Link prefetch={false} href={localizePathname(lang, href)} ref={ref} {...props}>
                {children}
            </Link>
        );
    });